export enum LayerType {
    Floor = 'floor',
    Walls = 'walls',
    Furnitures = 'furnitures',
    Details = 'details'
}